import { useMemo } from 'react';

import { GetMicrostoreColumnQuery } from 'data/__generated__';

import { AuditLogsSection } from 'components/AuditLogs/AuditLogsSection';
import type { SubjectLabels } from 'components/AuditLogs';

/**
 * L'historique d'une colonne — étagères et emplacements compris.
 *
 * Deux choses que seule cette page sait, et qui n'ont donc rien à faire côté serveur :
 * - modifier un planogramme n'écrit RIEN sur le document colonne, tout part sur ses emplacements :
 *   sans leurs identifiants, la section resterait vide sur l'action la plus courante de la page ;
 * - un identifiant d'emplacement ne dit rien à personne ; sa position, si.
 */
export const MicrostoreColumnAuditSection = ({
    microstoreColumn,
}: {
    microstoreColumn: GetMicrostoreColumnQuery['microstoreColumn'];
}) => {
    const { collectionDocumentIds, subjectLabels } = useMemo(() => {
        const documentIds = [microstoreColumn?._id].filter((id): id is string => Boolean(id));
        const labels: SubjectLabels = {};

        (microstoreColumn?.shelves ?? []).forEach((shelf) => {
            documentIds.push(shelf._id);
            labels[shelf._id] = `n°${shelf.positionInColumn + 1}`;

            shelf.locationTable.flat().forEach((location) => {
                documentIds.push(location._id);
                labels[location._id] = `(${location.positionInShelf.row + 1},${location.positionInShelf.column + 1})`;
            });
        });

        return { collectionDocumentIds: documentIds, subjectLabels: labels };
    }, [microstoreColumn]);

    return <AuditLogsSection collectionDocumentIds={collectionDocumentIds} subjectLabels={subjectLabels} />;
};
